<template>
  <div class="grid place-items-center gap-8">
    <RevIllustration
      src="/mine-my-phone/raw_intro_logo.svg"
      alt=""
      aria-hidden="true"
      :width="64"
      :height="64"
    />
    <h1 class="raw-heading-1">
      {{ i18n(headline) }}
    </h1>
    <h2 class="raw-heading-2 max-w-[20ch]">
      {{ i18n(subtitle) }}
    </h2>
  </div>
  <p class="max-w-[56ch]">
    {{ i18n(body) }}
  </p>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

// Two roots on purpose: the stage's `gap-32` is the seam between the title block and the copy.
defineProps<{
  headline: I18nDescriptor
  subtitle: I18nDescriptor
  body: I18nDescriptor
}>()

const i18n = useI18n()
</script>
